module.exports = __webpack_public_path__ + "img/wide.f3c94bf3.jpg";